import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const Separator = Box.withConfig({
  height: '1px',
  backgroundColor: primitive.$greyFour,
});
